/**
 * 模块名称: 日常办公 => 费用管理 => 申请页
 * @author liujingxue@372163.com
 */

import React, { useState, useEffect, useRef } from 'react'
import {
  Select,
  Input,
  Form,
  message,
  Row,
  Col,
  Upload,
  Icon,
  Modal,
  Button,
} from 'antd'
import api from '@/api'
import BtnGroup from '@/components/BtnGroup'
import { parseSearch, changeMoneyToChinese } from '@/utils'
import { upLoadModule } from '@/utils/common'
import '../assets/style.scss'

const { Option } = Select
const { Dragger } = Upload
const FormItem = Form.Item

const CostManagementApply = (props) => {
  const { location, history } = props
  const { getFieldDecorator, setFieldsValue, validateFields } = props.form

  const draggerRef = useRef(null)
  const [fileList, setFileList] = useState([])
  const [costClassId, setCostClassId] = useState('')
  const [companyList, setCompanyList] = useState([])
  const [costClassList, setCostClassList] = useState([])//获取费用类别
  const [payWayList, setPayWayList] = useState([])//获取付款方式
  const [moneyDx, setMoneyDx] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState('')

  const search = parseSearch(location.search)

  useEffect(() => {
    common()
    if (search.id) {
      api.getOfficeCostManagementDetail({ id: search.id, type: 1 }, true).then(res => {
        const fileLists = JSON.parse(res.attachments)
        setCostClassId(res.costClass)
        if (res.costClass !== 1) {
          setFieldsValue({
            costClassName: res.costClassDetailName
          })
        }
        setFieldsValue({
          costClass: res.costClass,
          companyId: res.companyId,
          payWay: res.payWay,
          payee: res.payee,
          bankName: res.bankName,
          bankAccount: res.bankAccount,
          money: res.money,
          remark: res.remark
        })
        if (fileLists.length) {
          fileLists.forEach((item, index) => {
            fileList.push({
              status: 'done',
              uid: index,
              name: item.name,
              url: item.url
            })
          })
          setFileList(fileLists.map((item, index) => ({ ...item, uid: index })))
        }
      })
    }
  }, [])

  //获取公共接口
  const common = () => {
    api.getOfficeCostManagementCostClass().then(res => setCostClassList(res)).catch(err => console.log(err))//获取费用类别
    api.getOfficeCostManagementPayWay().then(res => setPayWayList(res)).catch(err => console.log(err))//获取付款方式
    api.getHeadCompanyList({ limit: global.paramsLimit, type: 'feiyong' }).then(data => setCompanyList(data))//公司主体
  }

  //添加
  const handleSubmit = e => {
    e.preventDefault()
    validateFields((err, vals) => {
      let uploadList = []
      for (let i = 0, k = fileList.length; i < k; i++) {
        if (fileList[i].status !== 'removed') {
          uploadList.push({
            url: fileList[i].url,
            name: fileList[i].name
          })
        }
      }
      if (!err) {
        if (costClassId !== 1 && vals.costClassName) {
          const keywords = ["担保", "借款", "财务资助", "投资款", "房租"]
          const hasKeyword = keywords.some(keyword => vals.costClassName.includes(keyword))
          if (hasKeyword && ![17, 18, 19, 20].includes(Number(vals.costClass))) {
            setModalVisible(true)
            setModalContent(<p style={{textIndent: '1em'}}>该类别需经公司有权机构审议通过后申请付款，请确认是否已完成审议并在费用类别处准确选择费用类别。</p>)
            return
          }
        }
        
        api.setOfficeCostManagementApply({
          id: search.id && !search.type ? search.id : '',
          costClass: vals.costClass,
          costClassName: costClassId !== 1 ? vals.costClassName : '',
          companyId: vals.companyId,
          payWay: vals.payWay,
          payee: vals.payee,
          bankName: vals.bankName,
          bankAccount: vals.bankAccount,
          money: vals.money,
          remark: vals.remark,
          attachments: JSON.stringify(uploadList)
        }).then(res => {
          // console.log(res.message)
          if (res.status !== 'success') {
            return message.error(res.message)
          }
          history.push('/office/costManagement')
        })
      } else {
        message.error('请填写必填内容')
      }
    })
  }

  //取消返回列表页
  const onCancel = () => history.push('/office/costManagement')

  // 文件上传 
  const uploadFiles = upLoadModule({
    fileList: fileList,
    setFileList: setFileList,
    draggerRef: draggerRef,
    accept: '.gif, .png, .jpg, .PDF, .zip, .xls, .xlsx, .csv',
    limitNum: 20,
    allowSizeType: 3
  })

  //费用类别下拉获取具体名称
  const onSelectCostClass = (values, option) => {
    setCostClassId(values)
  }

  //付款金额
  const onChangeMoney = (e) => {
    if (e.target.value) {
      setMoneyDx(changeMoneyToChinese(e.target.value))
    } else {
      setMoneyDx('')
    }
  }

  return (
    <>
      <div className="cost-management-apply">
        <h1 className="cost-management-apply-title">{search.id && !search.type ? '费用驳回重提申请' : '费用申请'}</h1>
        <div className="line"></div>
        <Form onSubmit={handleSubmit}>
          <h3 className="cost-management-apply-tit">基本信息</h3>
          <Row gutter={24}>
            <Col span={6}>
              <FormItem label="费用类别">
                {getFieldDecorator('costClass', {
                  rules: [{ required: true, message: '请选择' }]
                })(<Select 
                      placeholder="请选择" 
                      dropdownMatchSelectWidth={false} 
                      onSelect={onSelectCostClass}
                      allowClear={true}
									    showSearch={true}
                      optionFilterProp="children"
                    >
                  {
                    costClassList.map((v, i) => {
                      return <Option value={v.id} key={i}>{v.name}</Option>
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
            {
              costClassId !== 1 ? <Col span={6}>
                <FormItem label="费用类别具体名称">
                  {getFieldDecorator('costClassName', {
                    rules: [{ required: true, message: '请输入' }]
                  })(<Input 
                      placeholder="请输入" 
                      onBlur={(e) => {
                        const value = e.target.value
                        const keywords = ['担保', '借款', '财务资助', '投资款', '房租', '投资', '资', '租', '借', '资助', '担', '保']
                        const hasKeyword = keywords.some(keyword => value.includes(keyword))
                        if (hasKeyword && ![17, 18, 19, 20].includes(Number(costClassId))) {
                          setModalVisible(true)
                          setModalContent(<p style={{textIndent: '1em'}}>该类别需经公司有权机构审议通过后申请付款，请确认是否已完成审议并在费用类别处准确选择费用类别。</p>)
                        }
                      }}
                    />)}
                </FormItem>
              </Col> : null
            }
            <Col span={6}>
              <FormItem label="公司主体">
                {getFieldDecorator('companyId', {
                  rules: [{ required: true, message: '请选择' }]
                })(<Select placeholder="请选择" dropdownMatchSelectWidth={false}>
                  {
                    companyList.map((v, i) => {
                      return <Option value={v.id} key={i}>{v.name}</Option>
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="付款方式">
                {getFieldDecorator('payWay', {
                  rules: [{ required: true, message: '请选择' }]
                })(<Select placeholder="请选择" dropdownMatchSelectWidth={false}>
                  {
                    payWayList.map((v, i) => {
                      return <Option value={v.id} key={i}>{v.name}</Option>
                    })
                  }
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <FormItem label="收款单位">
                {getFieldDecorator('payee', {
                  // rules: [{ required: true, message: '请输入' }]
                })(<Input placeholder="请输入" />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="开户行">
                {getFieldDecorator('bankName', {
                  // rules: [{ required: true, message: '请输入' }]
                })(<Input placeholder="请输入" />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="银行账号">
                {getFieldDecorator('bankAccount', {
                  // rules: [
                  //   { required: true, message: '请输入' }, 
                  //   {
                  //     pattern: /^-?[0-9]*(\.[0-9]*)?$/, message: '请输入正确的格式'
                  //   }]
                })(<Input placeholder="请输入" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <FormItem label="付款金额">
                {getFieldDecorator('money', {
                  rules: [{ required: true, message: '请输入' }, {
                    pattern: /^-?[0-9]*(\.[0-9]*)?$/, message: '请输入正确的格式'
                  }]
                })(<Input placeholder="请输入" onChange={onChangeMoney} />)}
              </FormItem>
            </Col>
          </Row>
          {
            moneyDx &&  <Row gutter={24}>
              <Col span={6}>
                <div>大写金额：{moneyDx}</div>
              </Col>
            </Row>
          }
          <Row gutter={24}>
            <Col span={16}>
              <FormItem label="附件">
                <div className="dragger-box" ref={draggerRef}>
                  <Dragger
                    {...uploadFiles}
                  >
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      附件支持格式：GIF、PNG、JPG、PDF、zip、xls、xlsx、csv  支持添加多个附件，单个附件大小不超过10M，文件数量不超过5个。
                    </p>
                  </Dragger>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={16}>
              <FormItem label="备注">
                {getFieldDecorator('remark')(
                  <Input.TextArea placeholder="请输入" maxLength={100} />
                )}
              </FormItem>
            </Col>
          </Row>
          <BtnGroup confirmName="提交" onCancel={onCancel} />
        </Form>
      </div>
      <Modal
        title="提示"
        visible={modalVisible}
        onOk={() => setModalVisible(false)}
        onCancel={() => setModalVisible(false)}
        closable={true}
        width={450}
        footer={[
          <Button key="submit" type="primary" onClick={() => setModalVisible(false)}>
            确认
          </Button>
        ]}
      >
        {modalContent}
      </Modal>
    </>
  )
}

export default Form.create()(CostManagementApply)